import { FlexRow } from '@/components/common/Flex';
import { Divider, FlexProps, Spinner } from '@chakra-ui/react';
import { FlexCol } from '../common/Flex';
import { disabledStyleProps } from '../common/styleHelpers';
import { BigHeader, LinkText, Text } from '../common/Typography';

export const GOAL_DETAIL_ITEM_CALLOUT_WIDTH = 18;

interface GoalDetailItemLayoutProps extends FlexProps {
    leftComponent?: JSX.Element;
    rightComponent?: JSX.Element;
    callout?: string | JSX.Element;
    label?: string | JSX.Element;
    link?: { text: string; onClick: VoidFunction; isDisabled?: boolean };
    isLoading?: boolean;
}

const GoalDetailItemLayout = ({
    leftComponent,
    rightComponent,
    callout,
    label,
    link,
    isLoading,
    ...props
}: GoalDetailItemLayoutProps) => {
    const left =
        leftComponent ??
        (isLoading ? (
            <Spinner size="sm" color="blue.500" />
        ) : (
            <BigHeader fontWeight="normal">{callout}</BigHeader>
        ));
    const right = rightComponent ?? (
        <>
            <Text fontWeight="medium" fontSize="md">
                {label}
            </Text>
            {link && (
                <LinkText
                    onClick={link.onClick}
                    {...disabledStyleProps(!!link.isDisabled)}
                >
                    {link.text}
                </LinkText>
            )}
        </>
    );

    return (
        <>
            <Divider my={7} />
            <FlexRow align="center" py={1} {...props}>
                <FlexRow justify="flex-end">{left}</FlexRow>
                <FlexCol ml={12}>{right}</FlexCol>
            </FlexRow>
        </>
    );
};
export default GoalDetailItemLayout;
